import React from "react";
import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../../shared";
import { PointPromotionList, AddorEditPointPromotion, PointPromotionDetails } from "./containers";

export const PointPromotions = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<PointPromotionList />} />
        <Route path="/details/:id" element={<PointPromotionDetails />} />
        <Route element={<ProtectedRoute allowedRoute={["customer-modify"]} />}>
          <Route path="/edit/:id" element={<AddorEditPointPromotion />} />
        </Route>
        <Route element={<ProtectedRoute allowedRoute={["customer-create"]} />}>
          <Route path="/create" element={<AddorEditPointPromotion />} />
        </Route>
      </Routes>
    </>
  );
};
